"use strict";
var datepicker = $.fn.bootstrap_datepicker;

export function feature_js_datepicker(el) {
    var $el = $(el);
    if ($el.filter('input').length === 0) $el.addClass('input-daterange');
    $el.addClass('date');
    // MS-1378: forward-looking hardening, inert today. All 12 current [js-datepicker]
    // consumers lock via `disabled`, which bootstrap-datepicker already refuses to open on,
    // so nothing changes for them. This keeps the option in sync with the other shared
    // initializer in Scripts/MashieDatePicker.4.js, so a future consumer that locks with
    // `readonly` instead does not silently inherit the bug this ticket fixed.
    datepicker.call($el, { todayHighlight: true, calendarWeeks: true, enableOnReadonly: false });
}